module.exports = __webpack_public_path__ + "static/img/specialservice.db1a59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialservice.png
// module id = 2HMe
// module chunks = 1